export default __webpack_public_path__ + "static/photo2-372bdddc39d447c798de8987ed511d78.png";